import { apiGet, apiPatch } from './client.js';

export interface UserPreferences {
  projectOrder?: number[];
  showAllProjects?: boolean;
  hiddenProjects?: number[]; // globally hidden project IDs
  kanbanFolds?: Record<string, Record<string, boolean>>; // Phase 31 D-21 — projectId → rowKey ('12' | 'no-milestone') → true (folded)
  boardColumnCollapse?: Record<string, Record<string, boolean>>; // quick 260726-dcz — projectId → stateId ('40' | 'null') → collapsed (explicit; absent = default = column.isTerminal)
  milestoneOrder?: Record<string, number[]>; // quick 260914-huu — projectId → ordered milestone ids (overlay over server default; see milestoneOrder.ts)
  // MKS-392 had a `showBirthdayToTeam` key here. It is gone (Petra, staging
  // check 2026-11-02): birthdays on the dashboard Upcoming card reach admin
  // and HR only, so there is nothing to opt out of. The backend's
  // `PreferencesSchema` is `.strict()` and now rejects the key, so do not
  // re-add it here without re-deciding the audience first.
  // MKS-393 — the /profile merch-sizes nudge banner's "don't show me this
  // again". ABSENT means not dismissed, so the banner shows for everyone who
  // has not seen it. It is only half the condition: the banner also needs all
  // six merch columns to be empty, which is read from the columns themselves,
  // so filling the sizes in hides it regardless of this key.
  merchSizesNudgeDismissed?: boolean;
  // MKS-493 — the visual theme. ABSENT means `default`. Mirrored into
  // `localStorage['ms-theme']` by ThemeProvider so the first paint of a new
  // session is right before this query resolves; this key is the
  // authoritative, cross-device copy.
  theme?: 'default' | 'sparkle';
  // MKS-491 — dark mode. ABSENT means light.
  colorScheme?: 'light' | 'dark' | 'system';
  // MKS-514 — task-detail comment thread order. ABSENT means `asc` (oldest first).
  commentOrder?: 'asc' | 'desc';
}

export function fetchPreferences(): Promise<{ data: UserPreferences }> {
  return apiGet('/auth/preferences');
}

export function updatePreferencesApi(data: Partial<UserPreferences>): Promise<{ data: UserPreferences }> {
  return apiPatch('/auth/preferences', data);
}
